import { render, staticRenderFns } from "./LandingPresentation.vue?vue&type=template&id=72051f80&scoped=true&"
import script from "./LandingPresentation.vue?vue&type=script&lang=ts&"
export * from "./LandingPresentation.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPresentation.vue?vue&type=style&index=0&id=72051f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72051f80",
  null
  
)

export default component.exports